export const defaultNumItemsPerSlide = 3;
export const defaultCurrentSlide = 1;
export const defaultNumReviews = 12;
export const defaultNumSlides = (defaultNumReviews / defaultNumItemsPerSlide); 